<template>
    <li class="border-b-xs border-neutral-light">
        <div
            class="p-lg flex justify-between"
            :class="{ 'border-l-lg border-neutral-light' : addressListIsVisible }"
        >
            <div>
                <input
                    :id="inputElementId"
                    v-model="sellerIsSelected"
                    type="radio"
                    class="mr-md"
                    :value="seller.id"
                    name="assign_seller"
                    @change="changeSelectedSeller"
                >
                <label :for="inputElementId" class="font-bold">
                    {{ seller.name }}
                </label>
            </div>
            <div class="flex justify-between">
                <div class="mr-2xl">
                    <font-awesome-icon icon="map-marker-alt" />
                    {{ seller.sales_period_addresses.length }}
                </div>
                <a
                    class="text-neutral-darkest font-bold"
                    :class="{ 'opacity-25': ! hasAssignedAddresses, 'cursor-pointer': hasAssignedAddresses }"
                    @click="showAddresses = ! showAddresses"
                >
                    <span v-if="addressListIsVisible">Dölj</span>
                    <span v-else>Visa</span>
                </a>
            </div>
        </div>

        <ul v-if="addressListIsVisible" class="list-reset">
            <li
                v-for="(address, index) in seller.sales_period_addresses"
                class="py-xl px-md border-l-lg border-neutral-light w-full"
                :class="{ 'border-b-xs' : isLastItem(seller.sales_period_addresses.length, index) }"
            >
                <div class="flex justify-between">
                    <span>
                        {{ address.address.street_name }} {{ address.address.street_number }}
                    </span>
                    <button
                        v-if="! isSigned(address)"
                        class="btn btn-sm is-ghost"
                        @click="unAssign(address)"
                    >
                        Frikoppla
                    </button>
                    <span v-else class="text-success">
                        <font-awesome-icon icon="check" class="text-accent-green" />
                        Signerad!
                    </span>
                </div>
            </li>
        </ul>
    </li>
</template>

<script>
    export default {
        props: {
            seller: {
                type: Object,
                required: true,
            },
            selectedAddresses: {
                type: [Array, Object],
                required: true,
            },
            selectedSeller: {
                type: Object,
                default: null,
            },
        },

        data() {
            return {
                showAddresses: false,
                sellerIsSelected: false,
            };
        },

        computed: {
            inputElementId() {
                return `assign_seller_${this.seller.id}`;
            },

            hasAssignedAddresses() {
                return this.seller.sales_period_addresses.length > 0;
            },

            addressListIsVisible() {
                return this.showAddresses && this.hasAssignedAddresses;
            },
        },

        watch: {
            selectedSeller() {
                if (! this.selectedSeller || ! this.seller) {
                    this.sellerIsSelected = false;

                    return;
                }

                if (this.selectedSeller.id !== this.seller.id) {
                    this.sellerIsSelected = this.selectedSeller.id === this.seller.id;
                }
            },
        },

        methods: {
            unAssign(salesPeriodAddress) {
                EventBus.$emit('un-assign-address', salesPeriodAddress);
            },

            isLastItem(addressesLength, index) {
                return addressesLength - 1 === index;
            },

            changeSelectedSeller(e) {
                EventBus.$emit('select-seller', this.seller, e.target.checked);
            },

            isSigned(salesPeriodAddress) {
                if (! salesPeriodAddress.address) {
                    return false;
                }

                return salesPeriodAddress.address.is_signed;
            },
        },
    };
</script>
